import useApiRequest from "@shared/hooks/common/useApiRequest";
import { ErrorResponse } from "@shared/types/commonTypes";
import { PerksResponse } from "@features/clinics/pages/perks/types";
import { useQuery } from "@tanstack/react-query";

type UsePerksResult = {
  perks: PerksResponse["perks"];
  categories: PerksResponse["categories"];
  companies: PerksResponse["companies"];
  isLoading: boolean;
  isFetching: boolean;
  error: ErrorResponse | null;
};

/**
 * Hook to fetch perks data.
 * Perks data is cached and used for displaying available perks.
 */
const usePerks = (): UsePerksResult => {
  const { GET } = useApiRequest();

  const fetchPerks = async (): Promise<PerksResponse> => {
    return GET<PerksResponse>("/api/perks");
  };

  const { data, isLoading, isFetching, error } = useQuery<
    PerksResponse,
    ErrorResponse
  >({ queryKey: ["perks"], queryFn: fetchPerks, enabled: true });

  return {
    perks: data?.perks || [],
    categories: data?.categories || [],
    companies: data?.companies || [],
    isLoading,
    isFetching,
    error: error ?? null,
  } satisfies UsePerksResult;
};

export default usePerks;

